import { jsx as r } from "react/jsx-runtime";
import t from "./index.es5645.js";
import i from "classnames";
import { ColorIndicator as e } from "./index.es26.js";
const p = ({
  testId: o = "color-indicator-cell",
  entityColor: l,
  gridDensity: a
}) => {
  const c = i(t.colorIndicatorCellRoot, t[a]);
  return /* @__PURE__ */ r("div", { className: c, "data-testid": o + "-container", children: /* @__PURE__ */ r(e, { entityColor: l, testId: o }) });
};
export {
  p as ColorIndicatorCell
};
//# sourceMappingURL=index.es627.js.map
